"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsService = void 0;
class SettingsService {
    constructor($http, toolbox) {
        this.$http = $http;
        this.toolbox = toolbox;
        this.baseUrl = 'Api/Settings';
    }
    getSettings() {
        var url = this.toolbox.createRequestUrl(this.baseUrl + '/');
        return this.$http.get(url)
            .then(response => response.data);
    }
}
exports.SettingsService = SettingsService;
SettingsService.$inject = ['$http', 'toolbox'];
